import { Box, useMediaQuery } from "@mui/material"
import { ReferanceCard } from "../components"
import DetectionProgression from "./DetectionProgression"
import ProgressionImageList from "./ProgressionImageList"
import { desktopEdHubReferences, mobileEdHubReferences } from "../../../assets/data/educationHub/referancesData"
import { theme } from "../../../utils"

const Imaging = () => {
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))

    return (
        <Box>
            <DetectionProgression/>
            <ProgressionImageList/>
            <ReferanceCard
                referanceData={isMobileX ? mobileEdHubReferences : desktopEdHubReferences}
            />
        </Box>
    )
}

export default Imaging
